<template>
  <div class="home">
      <!--<Doc class="marginal"></Doc>-->
      <div style="position: relative; overflow:hidden;padding-top:calc(100vh - 56.875px);">
        <embed src="https://doc.quanteec.com/"  style="position:absolute;top:0;left:0; width:100%;height:100%">
      </div>

  </div>
</template>

<script>
import Doc from '@/components/documentation/Doc.vue';
export default {
  name: 'DocPage',
  components: {
    Doc
  }
}
</script>